import type { IconNode } from '../types';

/**
 * @name floppy-disks-2
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAxOGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxMGw0IDR2MTBhMiAyIDAgMCAxLTIgMloiIC8+CiAgPHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iNCIgeD0iMTAiIHk9IjIiIC8+CiAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxMiIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTggMjJINGEyIDIgMCAwIDEtMi0yVjYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/floppy-disks-2
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const floppyDisks2: IconNode = [
  ['path', { d: 'M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10l4 4v10a2 2 0 0 1-2 2Z', key: '1rfswv' }],
  ['rect', { width: '7', height: '4', x: '10', y: '2', key: '1v0e9a' }],
  ['circle', { cx: '14', cy: '12', r: '2', key: 'ygwpk6' }],
  ['path', { d: 'M18 22H4a2 2 0 0 1-2-2V6', key: 'pblm9e' }],
];

export default floppyDisks2;
